import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=87cfa842&scoped=true"
import script from "./DynamicForm.vue?vue&type=script&lang=js"
export * from "./DynamicForm.vue?vue&type=script&lang=js"
import style0 from "./DynamicForm.vue?vue&type=style&index=0&id=87cfa842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cfa842",
  null
  
)

export default component.exports